import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 py-8 text-base leading-6 border-t border-red-900" style={{
    backgroundColor: 'rgb(5, 5, 5)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-126">
      <div className="mx-auto max-w-3xl text-center" data-id="element-127">
        {/* MARCA */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-red-500" data-id="element-128">
          🥋 CONSTRUYE PROGRESO™
        </div>

        {/* DESCRIPCIÓN */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-500 m-0 mb-3" data-id="element-129">
          El sistema de gestión profesional N°1 para instructores de artes
          marciales en Argentina.
        </p>

        {/* FRASE EMOCIONAL */}
        <p className="text-xs italic text-gray-600 m-0 mb-5" data-id="element-130">
          Porque un dojo bien gestionado no solo retiene más alumnos. Le cambia
          la vida al instructor que lo conduce.
        </p>

        {/* CONTACTO */}
        <div className="mb-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-gray-500" data-id="element-131">
          <span data-id="element-132">📧 construyeprogresoo@gmail.com</span>
          <span className="hidden sm:block text-gray-700" data-id="element-133">•</span>
          <span data-id="element-134">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-700" data-id="element-135">•</span>
          <span data-id="element-136">🌐 www.construyeprogreso.com</span>
        </div>

        {/* DIVISOR */}
        <div className="mb-5 h-px bg-red-900/30" data-id="element-137" />

        {/* COPYRIGHT */}
        <p className="text-[10px] text-gray-600 m-0 mb-1" data-id="element-138">
          © Construye Progreso™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-[10px] text-gray-700 m-0 mb-4" data-id="element-139">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}